import VerofreshRecord from './VerofreshRecord'

class RouteDataQualityRecord extends VerofreshRecord {
  static get FLAG_QUALITY_UNASSESSED () { return 2 ** 0 }
  static get FLAG_DURATION_TOO_SHORT () { return 2 ** 1 }
  static get FLAG_DURATION_TOO_LONG () { return 2 ** 2 }
  static get FLAG_OVERLAPPING_ROUTE () { return 2 ** 3 }
  static get FLAG_START_AFTER_DC_DEPARTURE () { return 2 ** 4 }
  static get FLAG_END_BEFORE_LAST_KNOWN_STOP () { return 2 ** 5 }
  static get FLAG_NO_DELIVERY_STOPS () { return 2 ** 6 }
  static get FLAG_MISSED_STOPS () { return 2 ** 7 }
  static get FLAG_STOPPED_AT_UNPLANNED_LOCATION () { return 2 ** 8 }
  static get FLAG_COOLER_SENSOR_FAILURE () { return 2 ** 9 }
  static get FLAG_FREEZER_SENSOR_FAILURE () { return 2 ** 10 }
  static get FLAG_GPS_SENSOR_FAILURE () { return 2 ** 11 }
  static get FLAG_FUTURE_TELEMETRY () { return 2 ** 12 }
  static get FLAG_TELEMETRY_REPORTED_LATE () { return 2 ** 13 }
  static get FLAG_ABNORMAL_AMBIENT_TEMPERATURE () { return 2 ** 14 }

  hasFlag (flag) {
    return (this.flags & flag) === flag
  }
}

export default RouteDataQualityRecord
